export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <circle cx="32" cy="32" r="31" fill="#D2462B" />
    <circle cx="32" cy="27" r="11" fill="#F29A2E" />
    <path d="M10 42c7-4 15-4 22 0s15 4 22 0v6c-7 4-15 4-22 0s-15-4-22 0z" fill="#F6EEDF" />
    <path d="M32 40c-2-9 1-17 8-23-3 8-4 15-2 23z" fill="#1F6B47" />
    <path d="M32 40c-4-6-11-9-18-8 6 2 11 5 15 9z" fill="#1F6B47" />
  </svg>
);

export const Logo = ({ light = true }) => (
  <span className="flex items-center gap-3">
    <LogoMark />
    <span className="leading-none">
      <span className={`block font-display text-xl font-semibold tracking-tight ${light ? "text-cream" : "text-cocoa"}`}>
        Sabor <em className="text-mango">Latino</em>
      </span>
      <span className={`block font-mono text-[10px] uppercase tracking-[0.22em] mt-1 ${light ? "text-cream/70" : "text-cocoa/70"}`}>
        Cocina Caribeña · GR
      </span>
    </span>
  </span>
);
